/**
 * Поля профиля, общие для личной информации и создания сотрудника.
 *
 * Раньше язык и часовой пояс в этих двух местах выглядели по-разному: в одном
 * списки, в другом свободный ввод, и написание вроде «Asia/Barnaul» приходилось
 * вспоминать наизусть. Поля живут здесь одним набором, чтобы человек видел одно
 * и то же, где бы он их ни заполнял.
 */

import { Select } from "./Select";

/** Часовой пояс со сдвигом: «Asia/Barnaul · GMT+07:00». */
function timezoneLabel(timezone: string): string {
  const offset =
    new Intl.DateTimeFormat("en", {
      timeZone: timezone,
      timeZoneName: "longOffset",
    })
      .formatToParts(new Date())
      .find((part) => part.type === "timeZoneName")?.value ?? "UTC";
  return `${timezone} · ${offset}`;
}

/** Языки интерфейса: русский по умолчанию, английский для внешних пользователей. */
const languages: ReadonlyArray<{ value: string; label: string }> = [
  { value: "ru", label: "Русский" },
  { value: "en", label: "English" },
];

export function LanguageSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <Select
      required
      aria-label="Язык"
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      {languages.map((language) => (
        <option key={language.value} value={language.value}>
          {language.label}
        </option>
      ))}
      {languages.every((language) => language.value !== value) ? (
        // Значение из базы может быть любым: не прячем его, иначе сохранение
        // молча подменило бы язык человека.
        <option value={value}>{value}</option>
      ) : null}
    </Select>
  );
}

export function TimezoneSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const timezones = Intl.supportedValuesOf("timeZone");
  return (
    <Select
      required
      aria-label="Часовой пояс"
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      {timezones.map((timezone) => (
        <option key={timezone} value={timezone}>
          {timezoneLabel(timezone)}
        </option>
      ))}
    </Select>
  );
}
